import React from "react";
import Moment from "moment";
import { DATE_FORMAT } from "../../../core/utils/i18n-js";
import { UserOutlined, CalendarOutlined, DeleteOutlined } from "@ant-design/icons";

import { Button, Popconfirm, List, Alert, Avatar } from "antd";

const ListItem = (props) => {
    const { item } = props;
    const dateFrom = Moment(item.dateFrom).format(DATE_FORMAT);
    const dateTo = Moment(item.dateTo).format(DATE_FORMAT);
    const dismiss = () => props.dismissEvent(item.id);
    const position = props.vendor ? "vendor" : "manager";
    const message = ` Between ${dateFrom} and ${dateTo}.`;

    return (
        <List.Item
            actions={[
                <Popconfirm title="Are you sure?" onConfirm={dismiss} okText="Remove" cancelText="No">
                    <Button ype="text" icon={<DeleteOutlined />} size="small">
                        REMOVE
                    </Button>
                </Popconfirm>,
            ]}
        >
            <List.Item.Meta
                title={
                    <>
                        <CalendarOutlined />
                        {message}
                    </>
                }
                description={item.notes}
            />
        </List.Item>
    );
};

const NotAvailable = (props) => {
    const { events } = props;

    if ((events || []).length < 1) {
        return null;
    }

    if ((events || []).length == 1) {
        const e = events[0];
        if (props.manager || props.vendor) {
            const dateFrom = Moment(e.dateFrom).format(DATE_FORMAT);
            const dateTo = Moment(e.dateTo).format(DATE_FORMAT);
            const dismiss = () => props.dismissEvent(e.id);
            const position = props.vendor ? "vendor" : "manager";
            return (
                <>
                    <Alert
                        message={`The ${position} is not available between ${dateFrom} and ${dateTo}. `}
                        type="warning"
                        showIcon
                        banner
                        description={e.notes}
                        action={
                            <Popconfirm title="Are you sure?" onConfirm={dismiss} okText="Remove" cancelText="No">
                                <Button ype="text" icon={<DeleteOutlined />} size="small">
                                    REMOVE
                                </Button>
                            </Popconfirm>
                        }
                    />
                </>
            );
        }
    }

    if (props.manager || props.vendor) {
        const position = props.vendor ? "vendor" : "manager";
        return (
            <>
                <Alert
                    message={`The ${position} is not available:  `}
                    type="warning"
                    howIcon
                    banner
                    description={(events || []).map((item) => (
                        <ListItem item={item} {...props} />
                    ))}
                />
            </>
        );
    }

    return null;
};

NotAvailable.defaultProps = {
    events: [],
    vendor: false,
    manager: false,
    dismissEvent: async () => {
        return;
    },
};

export default NotAvailable;
